import React, { useState, useContext, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useTranslation } from 'react-i18next'
import AppRouter from './routes/AppRouter'
import { ThemeProvider } from '@mui/styles'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { BrowserRouter as Router } from 'react-router-dom'
import Auth from './pages/Auth/Auth.page'
import { CurrentUserContextProvider } from './context/Shared/CurrentUser.context'
import { CurrentPortalContextProvider } from './context/Shared/CurrentPortal.context'
import { KioskModeContextProvider } from './context/Shared/KioskMode.context'
import { Amplify, Hub } from 'aws-amplify'
import awsconfig from './aws-exports'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { NotificationContext } from './context/Shared/Notification.context'
import NotificationPrompt from './components/Shared/NotificationPrompt/NotificationPrompt.component'

import './App.css'

Amplify.configure(awsconfig)

const App = () => {
  const { i18n } = useTranslation()
  document.body.dir = i18n.dir()

  const [user, setUser] = useState(null)
  const { authStatus } = useAuthenticator((context) => [context.authStatus])
  const { snackBarOpen, handleCloseSnackBar, snackBarMessage, snackBarType } =
    useContext(NotificationContext)

  useEffect(() => {
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'signIn':
          setUser(data.payload.data)
          Sentry.setUser({
            id: data.payload.data?.attributes?.sub,
            email: data.payload.data?.attributes?.email
          })
          break
        case 'signOut':
          setUser(null)
          Sentry.setUser(null)
          break
      }
    })
    return () => {
      Hub.remove('auth')
    }
  }, [])

  let theme = createTheme()
  theme = responsiveFontSizes(theme)
  return (
    <>
      <NotificationPrompt
        snackBarOpen={snackBarOpen}
        handleCloseSnackBar={handleCloseSnackBar}
        snackBarMessage={snackBarMessage}
        snackBarType={snackBarType}
      />
      {user || authStatus === 'authenticated'
        ? (
        <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
          <ThemeProvider theme={theme}>
            <CurrentUserContextProvider>
              <CurrentPortalContextProvider>
                <Router>
                  <KioskModeContextProvider>
                    <AppRouter />
                  </KioskModeContextProvider>
                </Router>
              </CurrentPortalContextProvider>
            </CurrentUserContextProvider>
          </ThemeProvider>
        </Sentry.ErrorBoundary>
          )
        : (
        <>
          <Auth />
        </>
          )}
    </>
  )
}

export default App
